var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStar2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.8925 0.67415C10.3573 -0.224716 11.6427 -0.224716 12.1075 0.67415L15.067 6.39808C15.1856 6.62746 15.3725 6.81435 15.602 6.93295L21.3258 9.8925C22.2247 10.3573 22.2247 11.6427 21.3258 12.1075L15.602 15.067C15.3725 15.1856 15.1856 15.3725 15.067 15.602L12.1075 21.3258C11.6427 22.2247 10.3573 22.2247 9.8925 21.3258L6.93295 15.602C6.81435 15.3725 6.62746 15.1856 6.39808 15.067L0.67415 12.1075C-0.224716 11.6427 -0.224716 10.3573 0.67415 9.8925L6.39808 6.93295C6.62746 6.81435 6.81435 6.62746 6.93295 6.39808L9.8925 0.67415Z",
    fill: "#00FFA3",
    fillOpacity: 0.3
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar2);
export default __webpack_public_path__ + "static/media/star_2.4196c20910c3a36abe60ebb64ec9b34f.svg";
export { ForwardRef as ReactComponent };